export const TELEPORT_ITEMS: {
    [key: string]: string;
} = {
    modal: '[data-modal-wrapper]',
    slideOutPanel: '[data-slide-out-panel]',
};

export const DEFAULT_DEBOUNCE_TIME = 300;
